import { pageState } from '~/store/page'
import { isLoggedIntoFb, loadFb } from './fb'
import { AppNavigation, ErrorReporter, Language } from '~/utils'

const signOut = async (
  useJwt = false,
  onDone: () => void = () => {
    return
  }
) => {
  try {
    if (useJwt) {
      await pageState.api.authentication_jwt.logout({})
    } else {
      await pageState.api.authentication.logout({})
    }

    if (pageState.config.fbAppId) {
      const isFbAvailable = await loadFb(
        pageState.config.fbAppId,
        Language.getInstance().language
      )
      if (isFbAvailable) {
        const isLoggedIn = await isLoggedIntoFb()
        if (isLoggedIn) {
          FB.logout(() => {
            onDone()
            AppNavigation.home()
          })
        }
      }
    }
    clearStorage()
    clearCookies()
    redirectToHome()
  } catch (error) {
    ErrorReporter.exception(error as Error)
    onDone()
    redirectToHome()
  }
}

const redirectToHome = () => AppNavigation.home()

const clearStorage = () => {
  localStorage.clear()
  sessionStorage.clear()
}

const clearCookies = () => {
  return document.cookie.split(';').reduce(function (acc, cookie) {
    const eqPos = cookie.indexOf('=')
    const cleanCookie = `${cookie.substring(
      0,
      eqPos
    )}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;`
    return `${acc}${cleanCookie}`
  }, '')
}

export { signOut }
